import { Component, OnInit } from '@angular/core';
import {Usermaster} from "../models/usermaster";
import {UsermasterService} from "../services/usermaster.service";
import {Router} from "@angular/router";
import {environment} from "../../../environments/environment";
declare var $ :any;
declare var bootbox: any;


@Component({
  selector: 'app-userlist',
  templateUrl: './userlist.component.html'
})
export class UserlistComponent implements OnInit {

    p: number[] = [];
    searchText: string = ''; 
    userlist:Usermaster[];

    constructor(
        private userService:UsermasterService,
        private router:Router,
    ) { }

    ngOnInit() {
        this.getUsers(0,{sortColumn: 'vName', sortDirection:'desc'});
        // $(document).ready(function() {
        //     $("#datatable").DataTable();
        // });
    }

    onSorted($event){
        this.getUsers(0,$event);
    }

    getUsers=function(pageId,criteria: UserListSearchCriteria){
        this.userService.getUserList(pageId,this.searchText).then(data => {
            console.log("UserList =======>",data);
            this.userlist = data['data']['data'];
            this.totaloffset = data['data'].Totaloffset;
            this.itemsperpage = data['data'].ItemsPerPage;
            this.SortUsers(criteria);     
        });
    }

    SortUsers(criteria: UserListSearchCriteria): Usermaster[] {
        return this.userlist.sort((a,b) => {
          if(criteria.sortDirection === 'desc'){
            if (a[criteria.sortColumn] < b[criteria.sortColumn]) {
                return 1
            } else {
                return 0
            }
          }
          else {
            if (a[criteria.sortColumn] > b[criteria.sortColumn]) {
                return 1
            } else {
                return 0
            }
          }
        });
    }

    viewUser(iUserId){
        this.router.navigate(['/users/',iUserId]);
    }

    deleteUser(iUserId,i){
        this.userService.deleteUserCall(iUserId).then(data => {
            console.log(data['code'])
            if(data['code'] === 200){
                $.toast({heading: 'Success', text: data['message'], position: 'top-right', showHideTransition: 'slide', icon: 'success'});
                this.getUsers(0,{sortColumn: 'vName', sortDirection:'desc'});
            }else{
                $.toast({heading: 'Warning', text: data['message'], position: 'top-right', showHideTransition: 'slide', icon: 'warning'});
            }
        }).catch(err => {
            if(err['code'] != 200){
                $.toast({heading: 'Error', text: err['message'], position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }else{
                $.toast({heading: 'Error', text: 'Server error! Please try again later', position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }
        });
    }

    deleteUserConfirm(iUserId,i){
        var _this = this;
        bootbox.confirm({
            message: "Are you sure you want to delete this record?",
            buttons: {
                confirm: {label: 'Yes',className: 'btn-success btn-flat'},
                cancel: {label: 'No',className: 'btn-default btn-flat'}
            },
            callback: function (result) {
                if(result) {
                    _this.deleteUser(iUserId,i);
                }
            }
        });
    }

}

export class UserListSearchCriteria {
    sortColumn: string;
    sortDirection: string;
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/usermaster/userlist/userlist.component.ts